export default __webpack_public_path__ + "static/media/desk3.73fc36f4.png";